import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
declare var $;
@Component({
  selector: 'sw-view-file',
  templateUrl: './sw-view-file.component.html',
  styleUrls: ['./sw-view-file.component.css']
})
export class SwViewFileComponent implements OnInit {

  constructor(
    private el : ElementRef,
    private http:SwHttpClientService, 
    private box:SwMassageBoxService,
  ) { }

  /**
   * 预览文件的路径
   */
  @Input() src:string

  //要预览的文件类型，默认是1，文档、Excel、PDF、文本使用 iframe 打开；2--音频（转码成 mp3）;3-视频（转码成 mp4）
  @Input() type:number = 1  

  @Input() fileName:string

  @Output() callback = new EventEmitter()

  /**
   * @ignore
   * 文件处理微服务api
   */
  fileUrl :string = environment.fileWebAPI

  /**
   * ifamar组件id
   * @ignore
   */
  ids:string

  /**
   * 播放状态，false-->暂停 ， true-->播放
   * @ignore
   */
  playStatus:boolean = false


  ngOnInit() {
    this.ids = "viewFile" + Math.random().toString().split(".")[1];
    if(this.type == 3){
      //如果文件类型是 视频，就要转码播放，后缀换成 mp4 的
      let arr = this.src.split('/')  
      //通过文件路径找到文件名
      let name = arr[arr.length-1]              
      //除文件名外的新路径
      arr.splice(arr.length-1,1)
      let newPath = arr.join('/')
      //拼接预览文件路径
      if(name){
        let index = name.lastIndexOf('.');
        name = name.substring(0,index)+'.mp4'
        this.src = newPath + '/TRANS/'+name
      }
    } else if(this.type == 2){
      //如果文件类型是 音频，只能预览音频30秒//如果文件类型是 视频，只能预览视频5秒
      let arr = this.src.split('/')  
      //通过文件路径找到文件名
      let name = arr[arr.length-1]              
      //除文件名外的新路径
      arr.splice(arr.length-1,1)
      let newPath = arr.join('/')
      //拼接预览文件路径
      if(name){
        let index = name.lastIndexOf('.');
        name = name.substring(0,index)+'.mp3'
        this.src = newPath + '/TRANS/'+name
      }
    }
  }

  ngAfterViewInit(): void {
    if(this.src && this.type == 1){
      this.src = this.fileSuffixConversion(this.src)
      this.src = this.src + '#toolbar=0'  //隐藏悬浮在头部的打印之类的按钮，
      $("#"+this.ids).attr("src",this.src)
    }  
  }

  ngOnChanges(): void {
   
  }

  /**
   * 转化文件后缀
   * 将doc 改成pdf
   * 将xslx改成html
   */
  fileSuffixConversion(filePath){
    let fileSuffix = filePath.split('.');
    switch(fileSuffix[fileSuffix.length-1].toLocaleLowerCase()){
      case "docx" : fileSuffix[fileSuffix.length-1] = "pdf";  break;
      case "doc"  : fileSuffix[fileSuffix.length-1] = "pdf"; break;
      case "xls"  : fileSuffix[fileSuffix.length-1] = "html";break;
      case "xlsx" : fileSuffix[fileSuffix.length-1] = "html";  break;
    }
    let url ="";
    fileSuffix.forEach(path => {
      url +=path+"."
    });
    return url.substring(0,url.length-1)
  }
  //图片
  //视频
  //word
  //pdf
  //xslx
  
  play(event){
    this.playStatus = true
  }

  //暂停
  pause(event){
    this.playStatus = false

  }
}
